// @flow

import PropTypes from 'prop-types';
import React from 'react';
import bemify from 'bemify-js';

import AvatarOrTeamLogoContainer from 'app/common/components/AvatarOrTeamLogoContainer';
import TruncatedText from 'app/common/components/TruncatedText';
import 'app/common/components/AccountInfo.scss';

const bem = bemify('account-info');

type Props = {
  accountId: number,
  meta?: string,
  title: string,
  hideDetails?: boolean,
};

const AccountInfo = ({ accountId, meta, title, hideDetails }: Props) => {
  const metaNode =
    hideDetails === true || !meta ? null : (
      <TruncatedText block={true} className={bem('__meta')}>
        {meta}
      </TruncatedText>
    );

  const details =
    hideDetails === true || (!meta && !title) ? null : (
      <div className={bem('__details')}>
        <TruncatedText block={true} className={bem('__title')}>
          {title}
        </TruncatedText>
        {metaNode}
      </div>
    );

  return (
    <div className={bem('__content')}>
      <AvatarOrTeamLogoContainer
        accountId={accountId}
        className={bem('__avatar')}
      />
      {details}
    </div>
  );
};

AccountInfo.propTypes = {
  accountId: PropTypes.number,
  meta: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default AccountInfo;
